/*
 * Copyright (c) 2020. American Express Company
 */

import BWDataService from './bw-data.service';
import { InstitutionModel } from 'src/types/institution.model';

export default class InstitutionService extends BWDataService {
    public static async deleteInstitution(institution: InstitutionModel): Promise<void> {
        await this.delete(`/institutions/${institution.id}`);
    }
}
